import React, { useState, useEffect } from "react";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  FormGroup,
  Label,
  Input,
  Col,
  Button,
} from "reactstrap";
import ModuleTypeIcon from "../../components/Module/ModuleTypeIcon";
import CreateNewScormModuleForm from "../Forms/CreateNewScormModuleForm";
import CreateNewLWModuleForm from "../Forms/CreateNewLWModuleForm";
import axios from "../../services/api/api";
import { API_BASE_URL } from "../../constants/api.constants";
import { toast } from "react-toastify";
import { FormattedMessage } from "react-intl";
import { useQueryClient } from "react-query";
import { TOAST_CONFIG } from "../../Utilities/toastConfig";

export default function CreateNewModule({
  toggle,
  isOpen,
  reloadModules,
  lwFileNames,
  moduleToEdit,
  gy25Modules,
  availableModuleStudyTasks,
}) {
  const [module, setModule] = useState(
    moduleToEdit !== null
      ? moduleToEdit
      : {
          name: "",
          url: "",
          code: "",
          lwGuid: "",
          description: "",
          moduleType: "",
          approveScoreLimit: 70,
          maxScore: 0,
          maxActivityPoints: 0,
          isFinalExam: false,
          maxScoreIsSetByModule: true,
          isFactModule: false,
          file: null,
          answers: null,
          studyTasks: null,
          affectedModules: [],
        },
  );
  const [errors, setErrors] = useState([]);
  const [saving, setSaving] = useState(false);
  const queryClient = useQueryClient();

  useEffect(() => {
    if (moduleToEdit !== null) {
      setModule(moduleToEdit);
    } else {
      setModule({
        name: "",
        url: "",
        code: "",
        lwGuid: "",
        description: "",
        moduleType: "",
        approveScoreLimit: 70,
        maxScore: 0,
        maxActivityPoints: 0,
        isFinalExam: false,
        maxScoreIsSetByModule: true,
        isFactModule: false,
        file: null,
        answers: null,
        studyTasks: null,
        affectedModules: [],
      });
    }
  }, [moduleToEdit]);

  const checkScorm = () => {
    let tempErrors = [...errors];
    if (module.name.length < 1) {
      if (!errors.includes("name")) {
        setErrors(tempErrors.push("name"));
      }
    }
    if (module.file === null) {
      if (!errors.includes("file")) {
        setErrors(tempErrors.push("file"));
      }
    }
    if (module.description === "") {
      if (!errors.includes("description")) {
        setErrors(tempErrors.push("description"));
      }
    }
    if (
      module.maxScoreIsSetByModule &&
      !module.isFactModule &&
      !module.isFinalExam &&
      module.qApiId?.length === 0
    ) {
      if (!errors.includes("qApiId")) {
        setErrors(tempErrors.push("qApiId"));
      }
    }
    setErrors(tempErrors);
    if (tempErrors.length > 0) {
      return false;
    } else {
      return true;
    }
  };

  const checkLearnware = () => {
    let tempErrors = [...errors];
    if (module.name.length < 1) {
      if (!errors.includes("name")) {
        setErrors(tempErrors.push("name"));
      }
    }
    if (module.description === "") {
      if (!errors.includes("description")) {
        setErrors(tempErrors.push("description"));
      }
    }
    if (module.url === "") {
      if (!errors.includes("url")) {
        setErrors(tempErrors.push("url"));
      }
    }
    if (module.lwGuid === "") {
      if (!errors.includes("lwGuid")) {
        setErrors(tempErrors.push("lwGuid"));
      }
    }
    if (module.code === "") {
      if (!errors.includes("code")) {
        setErrors(tempErrors.push("code"));
      }
    }
    setErrors(tempErrors);
    if (tempErrors.length > 0) {
      return false;
    } else {
      return true;
    }
  };

  const handleCheckForErrorsAndSave = () => {
    if (module.moduleType === "") {
    } else if (module.moduleType === "Scorm") {
      if (checkScorm()) {
        if (moduleToEdit === null) {
          setSaving(true);
          handlePostScorm();
        } else {
          setSaving(true);
          handleUpdateModule();
        }
      }
    } else {
      if (checkLearnware()) {
        if (moduleToEdit === null) {
          setSaving(true);
          handlePostLearnware();
        } else {
          setSaving(true);
          handleUpdateModule();
        }
      }
    }
  };

  const handleChangeModuleType = (modType) => {
    setErrors([]);
    setModule({
      name: "",
      url: "",
      code: "",
      lwGuid: "",
      description: "",
      moduleType: modType,
      approveScoreLimit: 70,
      maxScore: 0,
      maxActivityPoints: 0,
      isFinalExam: false,
      maxScoreIsSetByModule: true,
      isFactModule: false,
      file: null,
      answers: null,
      studyTasks: null,
      affectedModules: [],
    });
  };

  const toFormData = (file, fileName) => {
    if (!file) return null;

    var fileNameWithoutSpecialCharacters = file.name.toLowerCase();
    fileNameWithoutSpecialCharacters = fileNameWithoutSpecialCharacters
      .replace("ä", "a")
      .replace("å", "a")
      .replace("ö", "o");
    var myData = new FormData();
    myData.append(fileName, file, fileNameWithoutSpecialCharacters);
    return myData;
  };

  const handlePostLearnware = () => {
    axios
      .post(`${API_BASE_URL}/Module/`, {
        name: module.name,
        url: module.url,
        code: module.code,
        lwGuid: module.lwGuid,
        description: module.description,
        moduleType: 1,
        approveScoreLimit: module.approveScoreLimit,
        maxScore: module.maxScore,
        maxActivityPoints: module.maxActivityPoints,
        isFinalExam: module.isFinalExam,
        maxScoreIsSetByModule: module.maxScoreIsSetByModule,
        isFactModule: module.isFactModule,
        qApiId: module.qApiId,
        moduleCoupleId: module.moduleCoupleId,
      })
      .then((response) => {
        //POSTA FACIT OM DET FINNS
        var moduleId = response.data.result.id;
        if (module.answers !== null) {
          axios.post(
            "/Module/UploadModuleAnswers?moduleId=" + moduleId,
            toFormData(module.answers, "file"),
            { headers: { "Content-Type": "multipart/form-data;" } },
          );
        }

        toast.success("LW-Modulen har skapats", TOAST_CONFIG);
        reloadModules();
        setSaving(false);
        toggle();
      })
      .catch((err) => {
        toast.warn(
          err && err.response && err.response.data
            ? err.response.data
            : "Det gick inte att skapa modulen",
          TOAST_CONFIG,
        );
        setSaving(false);
      });
  };

  const handlePostScorm = () => {
    axios
      .post(`${API_BASE_URL}/Module/`, {
        name: module.name,
        url: module.name + "_tmpUrl",
        code: module.code,
        lwGuid: module.lwGuid,
        description: module.description,
        moduleType: 0,
        approveScoreLimit: module.approveScoreLimit,
        maxScore: module.maxScore,
        maxActivityPoints: module.maxActivityPoints,
        isFinalExam: module.isFinalExam,
        maxScoreIsSetByModule: module.maxScoreIsSetByModule,
        isFactModule: module.isFactModule,
        qApiId: module.qApiId,
        moduleCoupleId: module.moduleCoupleId,
      })
      .then((response) => {
        var moduleId = response.data.result.id;
        //Upload zipfile to api to unpack and set the correct url to the module there
        axios
          .post(
            "/Module/UploadScormToModule?moduleId=" + moduleId,
            toFormData(module.file, "zipFile"),
            { headers: { "Content-Type": "multipart/form-data;" } },
          )
          .then(() => {
            toast.success("Scorm-Modulen har skapats", TOAST_CONFIG);
            //POSTA FACIT OM DET FINNS
            if (!module.isFactModule && module.answers !== null) {
              axios
                .post(
                  "/Module/UploadModuleAnswers?moduleId=" + moduleId,
                  toFormData(module.answers, "file"),
                  { headers: { "Content-Type": "multipart/form-data;" } },
                )
                .then(() => {
                  queryClient.invalidateQueries([
                    "FetchAvailableModuleAnswers",
                  ]);
                  setSaving(false);
                  toggle();
                });
            } else if (module.isFactModule && module.studyTasks !== null) {
              axios
                .post(
                  "/Module/UploadModuleStudyTasks?moduleId=" + moduleId,
                  toFormData(module.studyTasks, "file"),
                  { headers: { "Content-Type": "multipart/form-data;" } },
                )
                .then(() => {
                  queryClient.invalidateQueries([
                    "FetchAvailableModuleStudyTasks",
                  ]);
                  setSaving(false);
                  toggle();
                });
            } else {
              if (module.affectedModules && module.affectedModules.length > 0) {
                handleUpdateAffectedModules(module.affectedModules);
              }
              if (!module.affectedModules?.length > 0) {
                reloadModules();
              }
              setSaving(false);
              toggle();
            }
          })
          .catch((err) => {
            toast.warn(
              err && err.response && err.response.data
                ? err.response.data
                : "Det gick inte att ladda upp modulen",
              TOAST_CONFIG,
            );
            setSaving(false);
          });
      })
      .catch((err) => {
        toast.warn(
          err && err.response && err.response.data
            ? err.response.data
            : "Det gick inte att skapa modulen",
          TOAST_CONFIG,
        );
        setSaving(false);
      });
  };

  const handleUpdateModule = () => {
    let file = module.file ? module.file : null;
    let url = module.urlInDb;
    if (module.moduleType === "LearnWare" && module.url !== module.urlInDb) {
      url = module.url;
    }
    axios
      .put(`${API_BASE_URL}/Module/`, {
        id: module.id,
        name: module.name,
        url: url,
        code: module.code,
        lwGuid: module.lwGuid,
        description: module.description,
        moduleType: module.moduleType === "LearnWare" ? 1 : 0,
        approveScoreLimit: module.approveScoreLimit,
        maxScore: module.maxScore,
        maxActivityPoints: module.maxActivityPoints,
        isFinalExam: module.isFinalExam,
        maxScoreIsSetByModule: module.maxScoreIsSetByModule,
        isFactModule: module.isFactModule,
        qApiId: module.qApiId?.length < 1 ? null : module.qApiId,
        moduleCoupleId: module.moduleCoupleId,
      })
      .then(() => {
        var moduleId = module.id;
        //POSTA FACIT OM DET FINNS
        if (!module.isFactModule && module.answers != null) {
          axios
            .post(
              "/Module/UploadModuleAnswers?moduleId=" + moduleId,
              toFormData(module.answers, "file"),
              { headers: { "Content-Type": "multipart/form-data;" } },
            )
            .then(() => {
              queryClient.invalidateQueries(["FetchAvailableModuleAnswers"]);
            })
            .catch((error) => {
              if (error.response.data.trim() === "ModuleNotFound") {
                toast.warn(
                  <FormattedMessage id="Error_Code_Module_Answers_ModuleNotFound" />,
                  TOAST_CONFIG,
                );
              } else {
                if (error && error.response) {
                  toast.warn(error.response.data);
                } else if (error && error.request) {
                  toast.warn(error.request.data);
                } else {
                  return <FormattedMessage id="GenericApiError" />;
                }
              }
            });
        }
        if (module.isFactModule && module.studyTasks != null) {
          axios
            .post(
              "/Module/UploadModuleStudyTasks?moduleId=" + moduleId,
              toFormData(module.studyTasks, "file"),
              { headers: { "Content-Type": "multipart/form-data;" } },
            )
            .then(() => {
              queryClient.invalidateQueries(["FetchAvailableModuleStudyTasks"]);
            })
            .catch((error) => {
              if (error && error.response) {
                toast.warn(error.response.data);
              } else if (error && error.request) {
                toast.warn(error.request.data);
              } else {
                return <FormattedMessage id="GenericApiError" />;
              }
            });
        }
        //If scorm-file is updated
        if (file !== null && module.moduleType === "Scorm") {
          //Upload zipfile to api to unpack and set the correct url to the module there
          axios
            .post(
              "/Module/UploadScormToModule?moduleId=" + moduleId,
              toFormData(module.file, "zipFile"),
              { headers: { "Content-Type": "multipart/form-data;" } },
            )
            .then((response) => {
              toast.success("Scorm-Modulen har skapats", TOAST_CONFIG);
              if (
                module.affectedModules !== undefined &&
                module.affectedModules.length === 0
              ) {
                reloadModules();
              }
              setSaving(false);
              toggle();
            })
            .catch((err) => {
              toast.warn(
                err && err.response && err.response.data
                  ? err.response.data
                  : "Det gick inte att ladda upp modulen",
                TOAST_CONFIG,
              );
              setSaving(false);
            });
        } else {
          toast.success("Modulen har uppdaterats", TOAST_CONFIG);
          if (!module.affectedModules?.length > 0) {
            reloadModules();
          }
          if (module.affectedModules && module.affectedModules.length > 0) {
            handleUpdateAffectedModules(module.affectedModules);
          }
          setSaving(false);
          toggle();
        }
      })
      .catch((err) => {
        toast.warn(
          err && err.response && err.response.data
            ? err.response.data
            : "Det gick inte att skapa modulen",
          TOAST_CONFIG,
        );
        setSaving(false);
      });
  };

  const handleUpdateAffectedModules = (affectedModules) => {
    affectedModules.forEach(async (mod, i) => {
      await axios
        .put(`${API_BASE_URL}/Module/`, {
          id: mod.id,
          name: mod.name,
          url: mod.url,
          code: mod.code,
          lwGuid: mod.lwGuid,
          description: mod.description,
          moduleType: mod.moduleType === "LearnWare" ? 1 : 0,
          approveScoreLimit: mod.approveScoreLimit,
          maxScore: mod.maxScore,
          maxActivityPoints: mod.maxActivityPoints,
          isFinalExam: mod.isFinalExam,
          maxScoreIsSetByModule: mod.maxScoreIsSetByModule,
          isFactModule: mod.isFactModule,
          qApiId: mod.qApiId,
          moduleCoupleId: mod.moduleCoupleId,
        })
        .then(() => {
          toast.success("Modulen har uppdaterats", TOAST_CONFIG);
        })
        .catch((err) => {
          toast.warn(
            err && err.response && err.response.data
              ? err.response.data
              : "Det gick inte att uppdatera modulen " + mod.name,
            TOAST_CONFIG,
          );
        })
        .finally(() => {
          if (i + 1 === affectedModules.length) {
            reloadModules();
          }
        });
    });
  };

  return (
    <Modal toggle={toggle} isOpen={isOpen} size="lg">
      <ModalHeader>
        {moduleToEdit === null ? "Skapa ny modul" : "Redigera modul"}
      </ModalHeader>
      <ModalBody>
        {moduleToEdit === null ? (
          <FormGroup row>
            <Label lg={3}>Modultyp</Label>
            <Col lg={3}>
              <Label check>
                <Input
                  type="radio"
                  name="moduleType"
                  checked={module.moduleType === "Scorm"}
                  onChange={() => handleChangeModuleType("Scorm")}
                />{" "}
                <ModuleTypeIcon moduleType="Scorm" />
                Scorm
              </Label>
            </Col>
            <Col lg={4}>
              <ModuleTypeIcon moduleType="Learnware" />
              <Label check>
                <Input
                  type="radio"
                  name="moduleType"
                  checked={module.moduleType === "LearnWare"}
                  onChange={() => handleChangeModuleType("LearnWare")}
                />{" "}
                LearnWare
              </Label>
            </Col>
          </FormGroup>
        ) : null}
        {module.moduleType === "Scorm" ? (
          <CreateNewScormModuleForm
            setModule={setModule}
            module={{ ...module }}
            errors={errors}
            setErrors={setErrors}
            moduleToEdit={moduleToEdit}
            gy25Modules={gy25Modules}
            availableModuleStudyTasks={availableModuleStudyTasks}
          />
        ) : module.moduleType === "LearnWare" ? (
          <CreateNewLWModuleForm
            setModule={setModule}
            module={{ ...module }}
            errors={errors}
            setErrors={setErrors}
            lwFileNames={lwFileNames}
          />
        ) : (
          ""
        )}
      </ModalBody>
      <ModalFooter>
        <Button
          outline
          color="secondary"
          disabled={saving}
          onClick={() => toggle()}
        >
          <FormattedMessage id="Cancel" />
        </Button>
        <Button
          outline
          color="primary"
          disabled={saving}
          onClick={() => handleCheckForErrorsAndSave()}
        >
          <FormattedMessage id="Save" />
        </Button>
      </ModalFooter>
    </Modal>
  );
}
